import React from 'react';
import { Facebook, Instagram, Twitter, Youtube, Mail, Phone, MapPin, ChevronUp } from 'lucide-react';
import LogoImage from './LogoImage';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black py-12 relative">
      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-primary hover:bg-red-600 text-white p-3 transition-all duration-300 hover:scale-110"
      >
        <ChevronUp size={24} />
      </button>

      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div>
            <div className="mb-4">
              <LogoImage
                height="h-12"
                showText={true}
                textSize="text-xl"
              />
            </div>
            <p className="text-gray-400 font-montserrat text-sm mb-4">
              World-renowned fitness resolutions focus on holistic, 
              long-term well-being rather than short-term results.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com/aiperformance.solutions" className="text-gray-400 hover:text-primary transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-montserrat font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-primary transition-colors font-montserrat text-sm">
                  About
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-primary transition-colors font-montserrat text-sm">
                  Services
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-gray-400 hover:text-primary transition-colors font-montserrat text-sm">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#challenges" className="text-gray-400 hover:text-primary transition-colors font-montserrat text-sm">
                  Challenges
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-montserrat font-bold text-white mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-400 font-montserrat text-sm">
                Strength & Conditioning
              </li>
              <li className="text-gray-400 font-montserrat text-sm">
                Health & Wellness Coaching
              </li>
              <li className="text-gray-400 font-montserrat text-sm">
                Home Gym Training
              </li>
              <li className="text-gray-400 font-montserrat text-sm">
                Outdoor Training
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-montserrat font-bold text-white mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <Mail className="text-primary mr-2 mt-1" size={16} />
                <a href="mailto:info@aiperformance.solutions" className="text-gray-400 hover:text-primary transition-colors font-montserrat text-sm">
                  info@aiperformance.solutions
                </a>
              </div>
              <div className="flex items-start">
                <Phone className="text-primary mr-2 mt-1" size={16} />
                <a href="tel:415-916-2448" className="text-gray-400 hover:text-primary transition-colors font-montserrat text-sm">
                  (415) 916-2448
                </a>
              </div>
              <div className="flex items-start">
                <MapPin className="text-primary mr-2 mt-1" size={16} />
                <span className="text-gray-400 font-montserrat text-sm">
                  1019 El Camino Real<br />
                  Menlo Park, CA 94025
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 font-montserrat text-sm mb-4 md:mb-0">
              © 2025 AI Performance Solutions. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-500 hover:text-primary transition-colors font-montserrat text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-primary transition-colors font-montserrat text-sm">
                Terms of Service
              </a>
            </div>
          </div>
        </div>

        {/* Powered By */}
        <div className="text-center mt-8">
          <p className="text-gray-600 font-montserrat text-xs">
            Powered by AI. Built with passion.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;